<script>
    import {axios, swal} from '../mixins';

    export default {
        name: 'RestoreConfirmation',

        mixins: [axios, swal],

        props: {
            url: {
                required: true,
                type: String,
            },
            name: {
                required: true,
                type: String,
            },
        },

        methods: {
            doRestore() {
                return this.swalConfirm('Confirm', `Please confirm the restoration of ${this.name}`).then((result) => {
                    if (result.value) {
                        this.swalLoading('', `Restoring ${this.name}...`);
                        this.post(this.url).then(() => {
                            this.swalClose();
                            this.swalSuccess('', `Successfully restored ${this.name}`).finally(() => {
                                this.$emit('restored', this.name);
                            });
                        }).catch(() => {
                            this.swalClose();
                            this.swalError('', `Failed to restore ${this.name}`);
                        });
                    }
                });
            },
        },
    };
</script>

<template>
    <button @click="doRestore">
        <slot></slot>
    </button>
</template>
